import { render, staticRenderFns } from "./ListaDetails.vue?vue&type=template&id=370a23b4&"
import script from "./ListaDetails.vue?vue&type=script&lang=js&"
export * from "./ListaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports